import './SearchSection.css';
import { SearchSectionProps } from './SearchSection.types';

/**
 * Search input component for filtering users and marketers

 */
export function SearchSection({ value, onChange }: SearchSectionProps) {
  return (
    <div className="user-management-search-section">
      <div className="user-management-search-field">
        <input
          placeholder="Пошук по електронній пошті, імені, ролі, телефону, статусу, сповіщенням..."
          value={value}
          onChange={e => onChange(e.target.value)}
          className="user-management-search-input"
        />
      </div>
    </div>
  );
}
